/**
 * FocusMe */

// Angular
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import {FocusMeDirective} from "./focusMe.directive";

// ng2-primene Components

@NgModule({
    imports: [
        CommonModule,
    ],
    declarations: [
        FocusMeDirective
    ],
    exports: [
        FocusMeDirective
    ]
})
export class FocusMeModule { }
